import React, {
  FunctionComponent, useState,
} from 'react';
import DateTimePicker from 'react-datepicker';
import './rangeDatePicker.scss';
import Input from '../input/Input';
import { CalendarNewIcon, CheckIcon, XIcon } from '../icons';
import Divider from '../divider/Divider';
import { Button } from '../button/Button';

type RangeDatePickerProps = {
  startDateValue: Date;
  endDateValue: Date;
  label: string;
  name?: string;
  className?: string;
  onRangeChange: (start: Date, end: Date) => void;
  clearButtonLabel?: string,
  confirmButtonLabel?: string,
  onConfirm: () => void,
  onClear: () => void,
  placeholderText?: string
}

const RangeDatePicker: FunctionComponent<RangeDatePickerProps> = ({
  startDateValue,
  endDateValue,
  label,
  name,
  className = '',
  onRangeChange,
  clearButtonLabel,
  confirmButtonLabel,
  onConfirm,
  onClear,
  placeholderText,
}) => {
  const [calendarOpened, setCalendarOpened] = useState(false);

  const onDateRangeChange = (value: [Date, Date]) => {
    const [startDate, endDate] = value;
    onRangeChange(startDate, endDate);
  };

  const confirmClick = () => {
    setCalendarOpened(false);
    onConfirm();
  };

  return (
    <div data-testid="custom-datepicker" className={`range-datepicker data-testid="custom-datepicker ${className}`}>
      <DateTimePicker
        startDate={startDateValue}
        endDate={endDateValue}
        onChange={onDateRangeChange}
        open={calendarOpened}
        onInputClick={() => setCalendarOpened(true)}
        selectsRange
        wrapperClassName="range-datepicker-wrapper"
        className="custom-datepicker"
        dateFormat="dd MMM yyyy"
        placeholderText={placeholderText || 'Start date - End date'}
        customInput={(
          <Input
            name="range-datepicker-custom-input"
            placeholder="Start date - End date"
            className={`range-datepicker-custom-input w-12 ${name}`}
            label={label}
            iconLeft={<CalendarNewIcon />}
            onClick={() => setCalendarOpened(true)}
            data-testid="datepicker_placeholder"
          />
        )}
      >
        <Divider className="m-t-28 m-b-20" />
        <div className="d-flex justify-content-space-between">
          <Button
            label={clearButtonLabel || 'Clear'}
            icon={<XIcon width={15} color="red5" />}
            priority="secondary"
            textColor="red5"
            variant="cancel"
            className="m-r-16"
            onClick={onClear}
            data-testid="datepicker_clear"
          />

          <Button
            label={confirmButtonLabel || 'Confirm'}
            icon={<CheckIcon width={15} color="blue5" />}
            priority="secondary"
            textColor="blue5"
            variant="info"
            onClick={confirmClick}
            data-testid="datepicker_confirm"
          />
        </div>
      </DateTimePicker>
    </div>
  );
};

export default RangeDatePicker;
